<template>
  <settings-modal
    class="deposit-decline-modal t-deposit-decline-modal"
  >
    <template slot="heading">Decline deposit {{ depositId }}?</template>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-decline-button"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_DEPOSIT_UPDATE } from '@/events/deposits'

  // Models
  import Deposit from '@/models/Deposit'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import DepositApi from '@/services/Api/DepositApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'DepositDeclineModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        depositDeclineApiRequest: new ApiRequest(DepositApi.decline, Deposit)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      depositId () {
        return this.modal.data.depositId
      },
      loading () {
        return this.depositDeclineApiRequest.loading
      },
      error () {
        return this.depositDeclineApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.declineDeposit(this.depositId)
          .then(deposit => {
            this.$eventHub.$emit(EVENT_DEPOSIT_UPDATE, deposit)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Deposit has been successfully declined.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      declineDeposit (depositId) {
        return this.depositDeclineApiRequest.execute(depositId)
      }
    }
  }
</script>
